var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

/* i=Change counter */
var charityCounter = document.getElementById("charity-counter");
if(charityCounter){
	
	var settings = {
		"async": true,
		"crossDomain": true,
		"url": "https://share.iequalchange.com/public/api/donations/livetotal?logo=1",
		"method": "GET",
		"headers": {
			"Authorization": "Basic NDU6TXJaYTlVWVBiNDZUVFhaNjN1UmpuNEJMTVNwZTVT",
			"Accept": "*/*"
		}
	}
	
	$.ajax(settings).done(function (response) {
		console.log('counter response: '+response); 
		var obj = JSON.parse(response);
		var donation = obj.donation.replace('.00','').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		document.getElementById("charity-counter").innerHTML = "We have so far donated…<br/><b>$" + donation + "</b><br/><em>& counting</em>";
	}); 
}
/*
const url = '/recommendations/products?section_id=related-products&product_id='+FIRST_VARIENT_ID+'&limit=2&intent=related';
	  
		fetch(url) 
		.then(response => response.text())
		.then(text => {
			const html = document.createElement('div');
			html.innerHTML = text;
			
			//console.log( html )
			recommendations = html.querySelector('.related-products--grid');
			//console.log( recommendations )
			recommendations = recommendations.children;
		
			console.log( recommendations )
						
			setTimeout(function() {
				let
				cart_recomendations_heading = document.getElementById("cart-recommendation-heading"),
				cart_recomendations = document.getElementById("cart-recommendations");
				
				if ( recommendations.length != 0) {
					console.log( recommendations[0] )
					cart_recomendations.style.display = 'block';
					cart_recomendations_heading.style.display = 'block';
					cart_recomendations.innerHTML = "";
					cart_recomendations.appendChild(recommendations[0]);
				}
				
				 
				if ( recommendations.length > 1) {
					console.log( recommendations[1] )
					cart_recomendations.appendChild(recommendations[1]);
				}
				
			}, 1000); 
			
		}) 
		.catch(e => {
			console.error(e);
		});
		/* */
$('.cart--form').submit(function(e) {
	$('.error-heading').remove();
	if ($('[name="attributes[packaging_options]"]').is(':checked')) {
		$(this).submit();
	}
	else {
		$('.cart-attribute__field').prepend('<span class="error-heading">Please select a packaging option:</span>')
		$('.cart-attribute__field').addClass('error')
		//alert("Please select a packaging option");

		setTimeout(function(){
			$('.cart-button--spinner').hide()
			$('.cart-button--text').show()
		}, 1000);
		
		return false;
		
	}
});

$('body').on('click', '.open-packaging-options', function(e) {
	e.preventDefault();
	$('#packaging-options').fadeIn();
});

$('.popup-wrapper:not(.no-close)').click(function(e) {
	if(e.target !== e.currentTarget) return;
	e.preventDefault();
	$(this).fadeOut();
}); 

$('.close-popup').click(function(e) {
	e.preventDefault();
	$(this).closest(".popup-wrapper").fadeOut();
});

function add_cart_product(){	
	const this_button = $('#cart-recommendations .cart-atc')

	$('#cart-recommendations .error').remove()
	this_button.html('Adding').attr('disabled','disabled');

	let variant_id = $('#cart-recommendations .cart-variant-id').val()
	 
	
	product_data = {
		quantity:1, 
		id: variant_id
	}
	
	fetch('/cart/add.js', {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest'
		},
		body: JSON.stringify(product_data)
	}).then((response) => {
		return new Promise((resolve) => response.json()
		.then((json) => resolve({
			status: response.status,
			ok: response.ok,
			json,
		})));
	}).then(({ status, json, ok }) => {
		switch (status) {
		case 422:
			//console.log(json);
			this_button.after('<p class="error">'+json.description+'</p>')
			this_button.html('Add to cart').removeAttr("disabled");
			break;
		case 201:
			break;
		case 200:
			//console.log(json);
			this_button.html('Success').css('background','#008060')
			break;
		case 500:
			break;
		default:
			//Any default tasks
		}
	}) 
}

/*
function swymCallbackFn(swat){
	// your API calls go here
	document.addEventListener("swym:collections-loaded", function(){
		swat.initializeActionButtons('.off-canvas--right-sidebar');
	})
}
if (!window.SwymCallbacks){
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);*/
